import React from 'react';
import styled from 'styled-components';

// 스타일 컴포넌트
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  color: #999;
`;

const ModalBody = styled.div`
  padding: 30px 20px;
  text-align: center;
`;

const SuccessTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #2282e9;
  margin-bottom: 20px;
`;

const SuccessMessage = styled.div`
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const ConfirmButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 50px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;

interface SuccessModalProps {
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>세금계산서</ModalTitle>
          <CloseIcon onClick={onClose}>✕</CloseIcon>
        </ModalHeader>
        <ModalBody>
          <SuccessTitle>신청 완료</SuccessTitle>
          <SuccessMessage>
            세금계산서 발행 신청이 완료되었습니다.<br/>
            영업일 기준 1-3일 정도 소요됩니다.<br/>
            다른 궁금하신 사항은<br/>
            문의하기로 문의주시기 바랍니다.
          </SuccessMessage>
          <ConfirmButton onClick={onClose}>
            완료
          </ConfirmButton>
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default SuccessModal; 